import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideSvgIcons, provideSvgIconsConfig, SvgIconComponent } from '@ngneat/svg-icon';
import allIcons from './library/svg-icons';
import { IconComponent } from './icon.component';
import { IconSizeConfig } from './icon-size-config.const';

interface SvgIconType {
	name: string;
	data: string;
}

const iconMap: any = { ...allIcons };
export const ICONS: SvgIconType[] = Object.keys(iconMap).map((name) => {
	return {
		name,
		data: iconMap[name],
	};
});

@NgModule({
	declarations: [IconComponent],
	exports: [SvgIconComponent, IconComponent],
	imports: [SvgIconComponent, CommonModule],
	providers: [provideSvgIconsConfig(IconSizeConfig), provideSvgIcons(ICONS)],
})
export class IconModule {}
